import React from 'react';
import { BaseMapItem } from 'types';

const BaseMapOptionItem: React.FC<Props> = ({
  item,
  selectedId,
  selectBaseMap
}) => {
  return (
    <div
      className={`map-style-base-map-item${
        selectedId === item.id ? ' selected' : ''
      }`}
      onClick={() => selectBaseMap(item)}
    >
      <div className="map-style-base-map-item-thumbnail">
        <img src={item.thumbnailUrl} alt="" />
      </div>
      <div className="map-style-base-map-item-label">
        <label>{item.title}</label>
      </div>
    </div>
  );
};

type Props = {
  item: BaseMapItem;
  selectedId?: string;
  selectBaseMap: Function;
};

export default React.memo(BaseMapOptionItem);
